import script from "./DrawTemplateSetup.vue?vue&type=script&setup=true&lang=js"
export * from "./DrawTemplateSetup.vue?vue&type=script&setup=true&lang=js"

import "./DrawTemplateSetup.vue?vue&type=style&index=0&id=600b8851&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-600b8851"]])

export default __exports__